import { useMemo } from "react";

import useUser from "./useUser";

export default function useBrandsOfUser() {
    const user = useUser();
    return useMemo(
        () => user
            ?.appMetadata
            ?.roles
            ?.filter?.((role) => role.role === "product-editor")
            ?.map?.((role) => role.resource.brandID)
            ?? [],
        [user],
    );
}
